export const SET_USER_DATA = "SET_USER_DATA";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_PAYMENT_METHODS = "SET_PAYMENT_METHODS";
export const SET_STRIPE_URI = "SET_STRIPE_URI";
export const SET_MESSAGING_TOKEN = "SET_MESSAGING_TOKEN";
export const SET_MESSAGING_CLIENT = "SET_MESSAGING_CLIENT";
export const SET_NOTIFICATION_COUNT = "SET_NOTIFICATION_COUNT";
